import React from "react";
import { useDispatch } from "react-redux";
import JobList from "../components/jobs/JobList";
import { searchJobs, sortJobs } from "../features/jobs/jobsSlice";

const Home = () => {
  const dispatch = useDispatch();
  const handleSearch = (value) => {
    dispatch(searchJobs(value));
  };
  const handleSort = (value) => {
    dispatch(sortJobs(value));
  };
  return (
    <div className="lg:pl-[14rem]  mt-[5.8125rem]">
      <main className="max-w-3xl rounded-lg  mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
        <div className="md:flex space-y-2 md:space-y-0 justify-between mb-10 ">
          <h1 className="lws-section-title">All Available Jobs</h1>
          <div className="flex gap-4">
            <div className="search-field group flex-1">
              <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500" />
              <input
                type="text"
                placeholder="Search Job"
                className="search-input"
                id="lws-searchJob"
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
            <select
              id="lws-sort"
              name="sort"
              autoComplete="sort"
              className="flex-1"
              onChange={(e) => handleSort(e.target.value)}
            >
              <option value="default">Default</option>
              <option value="lowtohigh">Salary (Low to High)</option>
              <option value="hightolow">Salary (High to Low)</option>
            </select>
          </div>
        </div>
        <JobList />
      </main>
    </div>
  );
};

export default Home;
